import {useState,useEffect} from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { ArrowDropDown,AddCircleOutline, HighlightOff } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { setHeader,setImgHeader } from '../services/Headers'
import { Url } from '../services/Constants'
import toast from 'react-hot-toast'

export default function Addproduct({isOpen, onClose}) {

    const [categorymenu, setCategorymenu] = useState(false)
    const [categorymenudata, setCategorymenudata] = useState("Select Category")
    const [gstmenu, setGstmenu] = useState(false) 
    const [gstmenudata, setdGstMenuData] = useState("Select GST")
    const [isPreviewImg, setIsPreviewImg] = useState(false)
    const [imagePreviews, setImagePreviews] = useState([]);
    const [isSoloImage, setIsSoloImage]  = useState(null)
    const [isVarient,setIsVarient] = useState(false)
    const [product_variants_attributes, setVariants] = useState([{ category_id:'', available_quantity: '', price: '', discounted_price: '', product_code:'', seller_id:'', weight:'',height:'',breadth:'', length:'', }]);
    const Navigate = useNavigate()
    const [category_id,setCategoryId] = useState()
    const [profile,setProfile] = useState()
    const [productName,setProductName] = useState()
    const [specification,setSpecification] = useState()
    const [images,setImages] = useState([])


    useEffect(() => {

        const checkPreLogin = async () => {
            try {
                const result = await axios.get(`${Url}/seller/get_profile`, setHeader());
                const user = result.data.response_code;
                setProfile(result.data.response_data)
                if (user===400) {
                    Navigate("/")
                }
                else{}
            }catch(error){
                console.log(error)
            }        
           
        };
        checkPreLogin()
    

        return () => {
          imagePreviews.forEach((preview) => URL.revokeObjectURL(preview));
        };
      }, [imagePreviews,category_id]);

      
    const categoryHandle = (e)=>{
        e.preventDefault()
        setCategorymenudata(e.target.innerText)
        setCategoryId(e.target.id)
        setCategorymenu(!categorymenu)
    }

    const gstHandle = (e)=>{
        e.preventDefault()
        setdGstMenuData(e.target.innerText)
        setGstmenu(!gstmenu)
    }
    

    const handleFileChange = (e)=>{
        const files = e.target.files;
        const fileArray = Array.from(files); 
        setImages(fileArray)
        const previewArray = [];
        fileArray.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                previewArray.push(reader.result); 
                if (previewArray.length === fileArray.length) {
                    setImagePreviews((prevPreviews) => [...prevPreviews, ...previewArray]);
                    setIsPreviewImg(true);
                }
            };
            reader.readAsDataURL(file);
        });

    }

    const handleDelete = (previewUrl) => {
        setImagePreviews((prevPreviews) =>
            prevPreviews.filter((url) => url !== previewUrl)
        );
        if (imagePreviews.length === 1) {
            setIsPreviewImg(false);
        }
        setIsSoloImage(null)
      };

    const handleImageView = (e)=>{
        setIsSoloImage(e.target.src)
      }


      const handleVariantChange = (index, field, value) => {
          let zerodata = [{...product_variants_attributes[0],category_id:category_id,seller_id:profile.seller_id}]
          let updatedVariants = [...product_variants_attributes];
          if(!updatedVariants[0].category_id){
            updatedVariants[0]={category_id:category_id, available_quantity: "", price: '', discounted_price: '', product_code:'', seller_id:profile.seller_id, weight:'',height:'',breadth:'', length:''}
          }
            updatedVariants[index][field] = value;
            setVariants(updatedVariants);
      };

      const addVariant = () => {
        setVariants([...product_variants_attributes, { category_id:category_id, available_quantity: "", price: '', discounted_price: '', product_code:'', seller_id:profile.seller_id, weight:'',height:'',breadth:'', length:'' }]);
      };
      
      const removeVariant = (index) => {
        const updatedVariants = product_variants_attributes.filter((_, idx) => idx !== index);
        setVariants(updatedVariants);
      };

      const dataSubmitHandle = async() =>{

        const hasNegativePrice = product_variants_attributes.some(variant =>
            (variant.price < 0 || variant.discounted_price < 0 || variant.available_quantity < 0 || variant.weight < 0 || variant.height < 0 || variant.breadth < 0 || variant.length < 0)
        );

        if (hasNegativePrice) {
            toast.error("value can not be in minus.");
            return;
        }
        if(productName && category_id!==undefined && category_id!== "0" && gstmenudata !== "Select GST" && specification){

            const formData = new FormData();

            formData.append('product[name]', productName);
            formData.append('product[specification]', specification);
            formData.append('product[category_id]', category_id);
            formData.append('product[is_variant]', isVarient);
            formData.append('product[gst]', gstmenudata);
            product_variants_attributes.forEach((variant, index) => {
                formData.append(`product[product_variants_attributes][${index}][category_id]`, variant.category_id);
                formData.append(`product[product_variants_attributes][${index}][available_quantity]`, variant.available_quantity);
                formData.append(`product[product_variants_attributes][${index}][price]`, variant.price);
                formData.append(`product[product_variants_attributes][${index}][discounted_price]`, variant.discounted_price);
                formData.append(`product[product_variants_attributes][${index}][product_code]`, variant.product_code);
                formData.append(`product[product_variants_attributes][${index}][seller_id]`, variant.seller_id);
                formData.append(`product[product_variants_attributes][${index}][weight]`, variant.weight);
                formData.append(`product[product_variants_attributes][${index}][height]`, variant.height);
                formData.append(`product[product_variants_attributes][${index}][breadth]`, variant.breadth);
                formData.append(`product[product_variants_attributes][${index}][length]`, variant.length);
              });
            images.forEach((image) => {
                formData.append("product[product_images][]", image);
              });
    
            try {
                const result =await axios.post(`${Url}/seller/products`,formData,setImgHeader())
                if(result.data.response_code===400){
                    toast.error("Please enter all varients details!")
                }else{
                    toast.success("Product added successfully.")
                    Navigate("/products")
                }
            } catch (error) {
                console.log(error)
            }


            
        }else{
            if(!productName){
            toast.error("Please enter product name!")
            return
            }
            if(category_id===undefined||category_id==="0"){
            toast.error("Please select category!")
            return
            }
            if(gstmenudata==="Select GST"){
            toast.error("Please select GST!")
            return
            }
            if(!specification)
            {
            toast.error("Please enter product specification!")
            return
            }
        }
    }

    

  return (
    <div className="product-container  ">
    <div className="product-top">
      <Navbar />
    </div>
    <div className="product-feed relative z-10 w-[70%] mx-auto top-3 mb-32  py-1 bg-slate-100 flex max-sm:flex-col">
        <div className="image-work w-full lg:w-1/2 flex flex-row items-center ">
    {isPreviewImg?<div className="preview-image bg-slate-200 max-w-16 px-1 pt-1 overflow-y-auto max-h-96 object-cover mr-2  max-sm:w-full">
                {imagePreviews.map((preview, index) => (
                <div key={index} className="relative mb-3">
                <img
                src={preview}
                alt={`Preview ${index}`}
                className="w-16 h-10 object-cover border rounded cursor-pointer"
                onClick={handleImageView}
                />
                <button
                onClick={() => handleDelete(preview)}
                className="absolute top-0 right-0 w-4 h-4 bg-red-500 text-[10px] text-white rounded-full"
                >
                X
                </button>
                </div>
                ))}
            </div>:""}
            {!isSoloImage?<div className="add-product-left bg-slate-200 w-[90%] min-h-96 flex py-5 items-center justify-center max-sm:w-[90%] max-sm:h-40">
            <input type="file" multiple accept='image/' id="icon-button" className="upload__inputfile hidden" onChange={handleFileChange}/>
            <label class="upload__btn flex flex-col justify-center items-center text-amber-950 cursor-pointer font-bold" htmlFor="icon-button">
            <div className="add-btn text-5xl border-2 border-amber-950 px-3 pb-2 rounded-lg">+</div>
            <p className='add-btn-title max-sm:text-center'>Product Images</p>
            </label>
            </div>:
            <div className="add-product-left relative bg-slate-200 w-[90%] flex flex-col items-center justify-center max-sm:w-[90%] max-sm:h-40">
              <img src={isSoloImage} alt="image.jpg" />
              <button
                onClick={() => setIsSoloImage(null)}
                className="absolute top-1 right-1 w-6 h-6 bg-red-500 text-sm font-bold text-white mx-auto rounded-full"
                >
                X
                </button>
            </div>}
            </div>

            <div className="add-product-right w-full lg:w-1/2 mx-auto max-sm:w-[90%] max-lg:w-[90%] max-sm:mx-auto max-sm:mt-4">
                            {/* <form action="" className="add-product-form flex flex-col items-center text-amber-950"> */}
                            <div className="product-name w-[90%] mx-auto mb-3 mt-3">
                           <input type="text" name="" id="" className=" w-full py-[1.5%] px-[1.5%] outline-none border border-amber-950 rounded-md " placeholder='Product Name' onChange={(e)=>setProductName(e.target.value)}/>
                            </div>
                           <div className="category-container w-[90%] mx-auto relative">
                           <div class="category-button control-form w-full border border-amber-950 rounded-md py-[1.5%] px-[1.5%] mb-3 cursor-pointer flex justify-between" onClick={()=>setCategorymenu(!categorymenu)}>
                            <span className="">{categorymenudata}</span>
                            <ArrowDropDown/>
                           </div>
                            {categorymenu?<ul class="category-menu p-[1%] pl-[2%] z-10 absolute bg-white border shadow-lg border-amber-950 rounded-md w-full -mt-2 max-sm:w-full">
                             <li id='0' className='mb-1 cursor-pointer' onClick={categoryHandle}>Select Category </li>
                             <li id="11" className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Cutting Tool </li>
                             <li id='12' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Hardware & Fitting</li>
                             <li id='13' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Adhesive</li>
                             <li id='14' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Spare Part</li>
                             <li id='15' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Service of Machine</li>
                             <li id='16' className='mb-1 hover:font-bold cursor-pointer' onClick={categoryHandle}>Regrinding Blade Tools</li>
                             <li class="divider"></li>                           
                           </ul>:"" } 
                           </div>
                           <div className="gst-container w-[90%] mx-auto relative">
                           <div className="gst-button w-full border border-amber-950 rounded-md py-[1.5%] px-[1.5%] mb-3 cursor-pointer flex justify-between" onClick={()=>setGstmenu(!gstmenu)} >
                            <span className="k">{gstmenudata}</span>
                            <ArrowDropDown/>
                            </div>  
                            {gstmenu?<ul class="gst-menu p-[1%] pl-[2%] z-10 absolute bg-white border shadow-lg border-amber-950 rounded-md w-full -mt-2 max-sm:w-full" >
                             <li className='mb-1 cursor-pointer' onClick={gstHandle}>Select GST </li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>5% </li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>12%</li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>18%</li>
                             <li className='mb-1 hover:font-bold cursor-pointer' onClick={gstHandle}>28%</li>                         
                           </ul>:""}
                           </div>
                           <div className="isvarient-container w-[90%] mx-auto mb-3 flex items-center ">
                           <input type="checkbox" name="isvarient" id="isvarient" className=" " onChange={()=>setIsVarient(!isVarient)} />
                           <label htmlFor="isvarient" className="ml-2">Is varient</label> 
                           {isVarient?<AddCircleOutline className='ml-5 cursor-pointer hover:text-amber-950' onClick={addVariant}/>:""}
                            </div>  


                           {/* product_variants_attributes ittration */}
                           <div className=' h-32 overflow-y-auto'>
                           {product_variants_attributes.length>0?product_variants_attributes.map((varient,index)=>(<div className="product_variants_attributes flex w-full mb-3 justify-end max-sm:flex-col items-end max-sm:w-full">
                           {index!==0?<HighlightOff className='cursor-pointer' onClick={()=>removeVariant(index)}/>:""}
                           <div key={index} className="size flex flex-col w-[12%] items-center max-sm:w-full ">
                                <span className="title max-sm:w-[90%] max-sm:text-start">Product Code</span>
                                <input type="text" name="" id="" className='outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]' onChange={(e) => handleVariantChange(index, 'product_code', e.target.value)}/>
                            </div>
                            <div className="qty flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start">Qty</span>
                                <input type="number" name="" min={1} id="" className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'available_quantity', e.target.value)}/>
                            </div>
                            <div className="price flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start">Price</span>
                                <input type="number" name="" min={1} id="" className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'price', e.target.value)}/>
                            </div>
                            <div className="discount flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start md:w-full md:text-center">Offer Price</span>
                                <input type="number" name="" min={1} id="" className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'discounted_price', e.target.value)}/>
                            </div>
                            <div className="price flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title  max-sm:w-[90%] max-sm:text-start">{`Weight (gm)`}</span>
                                <input type="number" name="" min={1} id="" className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'weight', e.target.value)} />
                            </div>
                            <div className="price flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title  max-sm:w-[90%] max-sm:text-start">{`Height (cm)`}</span>
                                <input type="number" name="" min={1} id="" className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'height', e.target.value)}/>
                            </div>
                            <div className="discount flex flex-col w-[12%] items-center max-sm:w-full">
                                <span className="title max-sm:w-[90%] max-sm:text-start md:w-full md:text-center">{`width (cm)`}</span>
                                <input type="number" name="" min={1} id="" className="outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]" onChange={(e) => handleVariantChange(index, 'breadth', e.target.value)}/>
                            </div>
                            <div className="size flex flex-col w-[12%] items-center max-sm:w-full ">
                                <span className="title max-sm:w-[90%] max-sm:text-start">{`Length (cm)`}</span>
                                <input type="number" name="" min={1} id="" className='outline-none border border-amber-950 w-[80%] rounded-md px-[5%] text-sm max-sm:w-[90%]' onChange={(e) => handleVariantChange(index, 'length', e.target.value)}/>
                            </div>
                           </div>)):""}
                           </div>

                           <div className="specificaion w-[90%] mx-auto flex flex-col mb-5 ">
                            <span className="k" >Specification</span>
                            <textarea name="" id="" className='outline-none border border-amber-950 rounded-md p-[2%] text-sm h-[30%] resize-none' onChange={(e)=>{setSpecification(e.target.value)}}></textarea>
                           </div>
                {/* </form> */}
                <div className="buttons flex w-[40%] justify-around mx-auto max-sm:w-[90%]">
                    <div className="submit bg-amber-950 rounded-lg text-white px-2 py-1 cursor-pointer hover:text-gray-400" onClick={dataSubmitHandle}>Add Product</div>
                    <div className="cancele bg-amber-950 rounded-lg text-white px-2 py-1 cursor-pointer hover:text-gray-400" onClick={()=>Navigate("/products")}>Cancel</div>
                </div>
    </div>
    </div>

    

    <div className=" product-bottom z-10 mb-0">
      <Footer/>
    </div>
  </div>
  )
}
